import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { useDispatch } from 'react-redux';
import CardFace from '../Card/CardFace';
import { PlainButton } from '../Controls';
import useCardDrag from '../Drag/useCardDrag';
import { TRAINER } from './handCardAction';

/**
 * A card in your hand you can tap (for its menu) or drag onto the board (useCardDrag). Dragging starts the card's
 * flow, which lights up where it can go, the same as tapping its menu button; letting go on a lit spot does what
 * tapping that spot would. Trainers, and cards that can't be played now, are tap only.
 */
const DraggableHandCard = ({ card, place, action, onTap }) => {
  const dispatch = useDispatch();
  const { bind, ghost } = useCardDrag({
    enabled: action.kind !== TRAINER && !action.reason,
    place,
    lift: () => {
      if (action.start) {
        dispatch(action.start());
      }
      return { kind: action.kind, handPosition: card.get('order') };
    },
    onMiss: () => action.cancel && dispatch(action.cancel()),
    // Quick, nearly flat swipes scroll the hand.
    touchAction: 'pan-x',
  });

  return (
    <>
      <PlainButton {...bind} onClick={onTap} aria-label={card.get('name')}>
        <CardFace card={card} />
      </PlainButton>
      {ghost(<CardFace card={card} />)}
    </>
  );
};

DraggableHandCard.propTypes = {
  card: PropTypes.instanceOf(Map).isRequired,
  /** The card's place on screen (Motion/anchorNames), so a card you drop doesn't fly there again. */
  place: PropTypes.string.isRequired,
  action: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    reason: PropTypes.string,
    start: PropTypes.func,
    cancel: PropTypes.func,
  }).isRequired,
  onTap: PropTypes.func.isRequired,
};

export default DraggableHandCard;
